import { Transition } from '@headlessui/react';
import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/components/ui/utils';
import { useIsMobile } from '../hooks/device.hook';
import { TappSidebar, TappSidebarProps } from '../TappSidebar';
import { useTappSidebar } from '../TappSidebar/sidebar.hook';

const styles = cva('', {
  variants: {},
  defaultVariants: {},
});

export type TappUIShellProps = {} & TappSidebarProps & VariantProps<typeof styles> & React.ComponentProps<'div'>;

export const TappUIShell: React.FC<TappUIShellProps> = ({
  items,
  logoUrl,
  logoSmallUrl,
  logoPosition,
  children,
  className,
  ...props
}) => {
  const sidebar = useTappSidebar();
  const isMobile = useIsMobile();

  return (
    <main className={cn('flex min-h-screen w-full items-stretch overflow-x-clip', styles({}), className)} {...props}>
      <TappSidebar items={items} logoUrl={logoUrl} logoSmallUrl={logoSmallUrl} logoPosition={logoPosition} />
      <section
        className={cn('grow overflow-y-clip p-4 transition-all duration-500 md:p-6 lg:p-8', {
          'w-[calc(100%_-_14rem)] md:ml-56': sidebar.isOpen && !sidebar.isCollapsed,
          'w-[calc(100%_-_5rem)] md:ml-20': sidebar.isOpen && sidebar.isCollapsed,
          'ml-0 w-full': !sidebar.isOpen,
        })}
      >
        {/* Backdrop when sidebar is opened */}
        <Transition
          as="div"
          className="fixed inset-0 z-40 h-screen w-screen bg-black/30"
          show={isMobile && sidebar.isOpen && !sidebar.isCollapsed}
          enter="transition-opacity duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity duration-500"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          onClick={() => sidebar.close()}
        ></Transition>
        {children}
      </section>
    </main>
  );
};
